import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "8px",
  },
  closeButton: {
    marginLeft: "8px",
    flexShrink: 0,
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "8px",
    marginTop: "24px",
  },
  textField: {
    marginTop: "8px",
  },
});
